/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { textEllipsis } from '../../../shared/utils/smartutils';
import { COMMUNICATION_TYPE } from '../../../shared/utils/constants';

export default function (t, type) {
  const columns = [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.title'),
      field: 'title',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.title}>
          {rowData.title}
        </span>
      ),
    },
    { title: t('general.sent'), field: 'sentDescription' },
    { title: t('general.is-scheduled'), field: 'scheduledDescription' },
    { title: t('general.created-at'), field: 'createdAtDate' },
    {
      title: t('general.scheduled-to'),
      field: 'scheduledToDate',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.scheduledToDate}>
          {rowData.scheduledToDate}
        </span>
      ),
    },
    {
      title: t('general.creator-name'),
      field: 'creatorName',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.creatorName}>
          {rowData.creatorName}
        </span>
      ),
    },
    {
      title: t('general.updater-name'),
      field: 'updaterName',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.updaterName}>
          {rowData.updaterName}
        </span>
      ),
    },
    {
      title: t('general.audit-status'),
      field: 'auditStatus',
    },
  ];
  if (type === COMMUNICATION_TYPE.EXAM) {
    columns.push({
      title: t('communication.due-date-EXAM'),
      field: 'dueDate',
    });
  }

  if (type === COMMUNICATION_TYPE.ACTIVITY) {
    columns.push({
      title: t('communication.due-date-ACTI'),
      field: 'dueDate',
    });
  }

  if (
    type === COMMUNICATION_TYPE.EXAM ||
    type === COMMUNICATION_TYPE.ACTIVITY
  ) {
    columns.push({
      title: t('general.closed'),
      field: 'formattedTaskEndedStatus',
    });
  }

  return columns;
}
